import usePostData from '../../../../../hooks/postHook';

export const useCreateNote = ({ productId }) => {
  const endpoint = `case/${productId}/notes`;

  const [{ data, body, isLoading, isError, error }, doCreateNote] =
    usePostData(endpoint);

  return {
    data,
    body,
    isLoading,
    isError,
    error,
    doCreateNote,
  };
};
